import { render } from "./modelconfig.vue?vue&type=template&id=4cea5e0e"
import script from "./modelconfig.vue?vue&type=script&lang=js"
export * from "./modelconfig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__